var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAuthenticated)?_c('authenticated-layout'):_c('guest-layout')}
var staticRenderFns = []

export { render, staticRenderFns }